// src/shared/components/ui/popover.tsx
import * as React from 'react'
import * as RadixPopover from '@radix-ui/react-popover'
import clsx from 'classnames'

export const Popover = RadixPopover.Root
export const PopoverTrigger = RadixPopover.Trigger

export const PopoverContent = React.forwardRef<
  HTMLDivElement,
  RadixPopover.PopoverContentProps
>(({ className, sideOffset = 5, ...props }, ref) => (
  <RadixPopover.Portal>
    <RadixPopover.Content
      ref={ref}
      sideOffset={sideOffset}
      className={clsx(
        'z-50 pac-glass-raised rounded-md p-4',
        className
      )}
      {...props}
    >
      {props.children}
      <RadixPopover.Arrow className="fill-neutral-800" />
    </RadixPopover.Content>
  </RadixPopover.Portal>
))
